export const selectCurrentLanguage = (state) => state.language.currentLanguage;
